import {
  type HistoryGroup,
  getHistoryId,
  isHistoryGroup,
} from "@/features/history/utils";
import { useModals } from "@/features/modals/hooks";
import {
  type History,
  HistoryEntryTypeEnum,
  type Opportunity,
  getDrawings,
} from "@repo/api";
import { LightMode, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { SimpleLabelField } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface Props {
  history: History | HistoryGroup;
  opportunity: Opportunity;
}

export const PlannerHistoryItem = ({ history, opportunity }: Props) => {
  const { pushModal } = useModals();
  const entryId = getHistoryId(history);
  const drawings = getDrawings(opportunity.planners);
  const drawing = drawings.find((item) => item.id === entryId);
  const isPlannerAssociated =
    history.entryType === HistoryEntryTypeEnum.PLANNER_ASSOCIATED;

  const description = isPlannerAssociated ? (
    <>
      <Text textStyle="Body.S">{history.body}</Text>
      {history.details?.planner_type && (
        <SimpleLabelField
          small
          label={t("label.planner_type")}
          value={history.details?.planner_type}
          color={LightMode.colourTextAndIcon2}
        />
      )}
    </>
  ) : (
    <Text textStyle="Body.S">{history.note}</Text>
  );

  const historyEntries = isHistoryGroup(history)
    ? history.prevEntries
    : undefined;

  return (
    <HistoryListViewItem
      history={history}
      control={drawing ? "navigational" : "default"}
      onClick={() => {
        if (drawing) {
          pushModal({
            type: "PLANNER",
            drawing,
            historyEntries,
          });
        }
        trackAnalytics("planner_history");
      }}
      title={history.title}
      description={description}
    />
  );
};
